import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoDismiss: { type: Number, default: 3000 }
  }

  connect() {
    this.startTimer()
    this.animateEntrance()
  }

  disconnect() {
    this.clearTimer()
  }

  pause() {
    this.clearTimer()
  }

  resume() {
    this.startTimer()
  }

  dismiss() {
    this.clearTimer()
    this.animateExit().then(() => {
      this.element.remove()
    })
  }

  clearTimer() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  startTimer() {
    this.clearTimer()
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, this.autoDismissValue)
  }

  get slideOffset() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return "0px"
    }
    const rect = this.element.getBoundingClientRect()
    // If element is in top half of viewport, slide down from -0.5rem.
    // If element is in bottom half, slide up from 0.5rem.
    return rect.top < window.innerHeight / 2 ? "-0.5rem" : "0.5rem"
  }

  animateEntrance() {
    const offset = this.slideOffset
    this.element.style.opacity = "0"
    this.element.style.transform = `translateY(${offset})`

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.style.opacity = "1"
        this.element.style.transform = "translateY(0)"
      })
    })
  }

  animateExit() {
    const offset = this.slideOffset
    return new Promise((resolve) => {
      this.element.style.transition = "opacity 200ms ease-in, transform 200ms ease-in"
      this.element.style.opacity = "0"
      this.element.style.transform = `translateY(${offset})`
      setTimeout(resolve, 200)
    })
  }
}
